import React, { useEffect, useContext, useState, useRef } from "react";
import { useHistory } from "react-router-dom";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  formatPrice,
  getSystemSettings,
} from "../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Moment from "react-moment";
import moment from "moment";
import Select from "react-select";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useReactToPrint } from "react-to-print";

//pages & includes
import ReportSidebar from "./ReportSidebar";

//context consumer
import { SettingsContext } from "../../../../contexts/Settings";
import { RestaurantContext } from "../../../../contexts/Restaurant";
import { FoodContext } from "../../../../contexts/Food";
import CustomSpinLoader from "../../../components/CustomSpinLoader";

const FgAdjustmentReport = () => {
  const { t } = useTranslation();
  const history = useHistory();
  //getting context values here
  let {
    loading,
    setLoading,
    dataPaginating,
    setDataPaginating,
    generalSettings,
  } = useContext(SettingsContext);
  let { branchForSearch } = useContext(RestaurantContext);
  let { foodForPOS } = useContext(FoodContext);

  //all data
  const [reportData, setReportData] = useState(null);
  const componentRef = useRef();
  const componentRefThermal = useRef();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [branch, setBranch] = useState(null);
  const [item, setItem] = useState(null);
  const [generatedReport, setGeneratedReport] = useState(false);
  const [siteName, setSiteName] = useState("");
  const [option, setOption] = useState("excel");

  useEffect(() => {
    setSiteName(getSystemSettings(generalSettings, "siteName"));
  
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, [generalSettings]);

  const thermalPrint = useReactToPrint({
    content: () => componentRefThermal.current,
    pageStyle:`
        @page {
          size: landscape;
          margin: 15px;
        }
      `
  });

  const handleBranch = (branch) => {
    setBranch(branch);
  };

  const handleItem = (item) => {
    setItem(item);
  };

  const handleOption = (e) => {
    setOption(e.target.value);
  };

  //get BranchWise reports filter
  const getBranchWiseSelected = () => {
    setReportData(null);
    setGeneratedReport(false);
    if (startDate !== null && endDate !== null && branch !== null) {
      setDataPaginating(true);
      var fromDate = moment(startDate).format("YYYY-MM-DD");
      var toDate = moment(endDate).format("YYYY-MM-DD");
      const url = BASE_URL + "/settings/finished-goods-adjustment-report";
      let formData = new FormData();
      formData.append("fromDate", fromDate);
      formData.append("toDate", toDate);
      formData.append("branch_id", branch?.id);
      formData.append("item_id", item ? item?.id : "");

      return axios
        .post(url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          console.log("ReportResult", res);
          setGeneratedReport(true);
          setReportData(res.data);
          setDataPaginating(false);
          if (option === "excel") {
            componentRef.current.handleDownload();
          } else {
            thermalPrint();
          }
        })
        .catch((error) => {
          setDataPaginating(false);
        });
    } else {
      toast.error(`${_t(t("Please select from date, to date and branch"))}`, {
        position: "bottom-center",
        closeButton: false,
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    }
  };

  let totalQty = 0;
  let totalActualStock = 0;
  let totalAdjustedQty = 0;
  let itemPrintQty = 0;
  let itemActualPrintStock = 0;
  let itemAdjustedPrintQty = 0;

  return (
    <>
      <Helmet>
        <title>{_t(t("FG Adjustment Report"))}</title>
      </Helmet>
      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="table-to-xls"
        filename="FG Adjustment Report"
        sheet="sheet 1"
        buttonText="FG Adjustment Detail"
        ref={componentRef}
      />

      {/* Excel Report*/}
      <div className="d-none">
        <div>
          <div className="fk-print">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  {reportData !== null &&
                    reportData !== undefined &&
                    generatedReport === true && (
                      <>
                        <div className="row gx-2 justify-content-center t-pb-15 t-pt-15 report">
                          <div className="col-12 t-mb-15 mb-md-0 table-responsive">
                            <table
                              className="table table-bordered"
                              id="table-to-xls"
                            >
                              <div className="page-break"></div>
                              <thead className="align-middle">
                                <tr style={{ border: "0px" }}>
                                  <th colspan="8" style={{ border: "0px" }}>
                                    <div className="row">
                                      <div className="col-12">
                                        <h3 className="text-center mb-0">
                                          {siteName}
                                        </h3>
                                        <h3 className="text-center mt-0">
                                          Finished Goods Adjustment Report
                                        </h3>
                                        <p className="text-center">
                                          FROM&nbsp;
                                          <Moment format="LL">
                                            {startDate}
                                          </Moment>
                                          &nbsp;TO&nbsp;
                                          <Moment format="LL">{endDate}</Moment>
                                        </p>
                                      </div>
                                    </div>
                                  </th>
                                </tr>
                                <tr>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("S/L"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Document No"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Document Date"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Branch"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Item"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Qty"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Actual Stock"))}
                                  </th>

                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Adjusted Qty"))}
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="align-middle">
                                {reportData && reportData.map((item, i) => {
                                  totalQty += parseFloat(item?.qty || 0);
                                  totalActualStock += parseFloat(
                                    item?.actual_stock || 0
                                  );
                                  totalAdjustedQty += parseFloat(
                                    item?.adjusted_qty || 0
                                  );
                                  return (
                                    <tr key={i}>
                                      <td>
                                        {i + 1}
                                      </td>
                                      <td>
                                        {item?.document_identity}
                                      </td>
                                      <td>
                                        <Moment format="LL">
                                          {item.document_date}
                                        </Moment>
                                      </td>
                                      <td>
                                        {item?.branch_name}
                                      </td>
                                      <td>
                                        {item?.item_name}
                                      </td>
                                      <td>
                                        {parseInt(item?.qty || 0)}
                                      </td>
                                      <td>
                                        {parseInt(item?.actual_stock || 0)}
                                      </td>
                                      <td>
                                        {parseInt(item?.adjusted_qty || 0)}
                                      </td>
                                    </tr>
                                  );
                                })}

                                <tr>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td>
                                    <strong>Total</strong>
                                  </td>
                                  <td>
                                    <strong>{totalQty}</strong>
                                  </td>
                                  <td>
                                    <strong>{totalActualStock}</strong>
                                  </td>
                                  <td>
                                    <strong>{totalAdjustedQty}</strong>
                                  </td>
                                </tr>
                              </tbody>

                              <tfoot style={{ border: "0px" }}>
                                <tr style={{ border: "0px" }}>
                                  <td
                                    colspan="8"
                                    className="text-center"
                                    style={{ border: "0px" }}
                                  >
                                    <h5 className="mt-3">
                                      Powered by indolj.pk
                                    </h5>
                                  </td>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        </div>
                      </>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* print */}
      <div className="d-none">
        <div ref={componentRefThermal}>
          <div className="fk-print mx-2 my-3">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div>
                    <span className="mt-1 d-block fk-print-text_pos font-weight-bold text-uppercase text-center table-text">
                      {siteName}
                    </span>
                  </div>
                  <div>
                    <span className="mt-1 d-block fk-print-text_pos font-weight-bold text-uppercase text-center table-text">
                      FROM&nbsp;
                      <Moment format="LL">{startDate}</Moment>
                      &nbsp;TO&nbsp;
                      <Moment format="LL">{endDate}</Moment>
                    </span>
                  </div>
                  <div>
                    <span className="mt-1 d-block fk-print-text_pos font-weight-bold text-uppercase text-center table-text">
                      Print Time: <Moment format="LLL">{new Date()}</Moment>
                    </span>
                  </div>
                  <span className="mt-1 d-block fk-print-text_pos font-weight-bold text-uppercase text-center table-text mb-2">
                    Finished Goods Adjustment Report
                  </span>
                  {/*fg report */}
                  {reportData && reportData.length > 0 && (
                    <div className="col-12">
                      <table className="table-bordered responsive sm-text">
                        <thead>
                          <tr>
                            <th className="p-2 border border-1">Document Identity</th>
                            <th className="p-2 border border-1 border border-1">Document Date</th>
                            <th className="p-2 border border-1">Branch Name</th>
                            <th className="p-2 border border-1">Item Name</th>
                            <th className="text-end p-2 border border-1">Qty</th>
                            <th className="text-end p-2 border border-1">Actual Stock</th>
                            <th className="text-end p-2 border border-1">Adjusted Qty</th>
                          </tr>
                        </thead>
                        <tbody>
                          {reportData && reportData.map((item, itemIndex) => {
                            itemPrintQty += parseInt(item.qty);
                            itemActualPrintStock += parseInt(
                              item.actual_stock
                            );
                            itemAdjustedPrintQty += parseInt(
                              item.adjusted_qty
                            );

                            return (
                              <tr key={itemIndex}>
                                <td className="p-2">{item.document_identity}</td>
                                <td className="p-2">
                                  <Moment format="LL">
                                    {item.document_date}
                                  </Moment>
                                </td>
                                <td className="p-2">{item.branch_name}</td>
                                <td className="p-2">{item.item_name}</td>
                                <td className="text-end p-2">
                                  {parseInt(item.qty)}
                                </td>
                                <td className="text-end p-2">
                                  {parseInt(item.actual_stock)}
                                </td>
                                <td className="text-end p-2">
                                  {parseInt(item.adjusted_qty)}
                                </td>
                              </tr>
                            );
                          })}
                          <tr className="">
                            <td colSpan="4" className="text-end p-2" >
                              <strong>Total</strong>
                            </td>
                            <td className="text-end p-2">
                              <strong>{itemPrintQty}</strong>
                            </td>
                            <td className="text-end p-2">
                              <strong>{itemActualPrintStock}</strong>
                            </td>
                            <td className="text-end p-2">
                              <strong>{itemAdjustedPrintQty}</strong>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ReportSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    {/* next page data spin loading */}
                    <CustomSpinLoader loading={loading || dataPaginating}/>

                    {/* spin loading ends */}

                    {/* Loading effect {loading === true ? (
                        tableLoading()
                      ) : ( */}

                    <div key="smtp-form">
                      <div className="gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="row t-mb-15 mb-md-0">
                          <ul className="t-list fk-breadcrumb col-6">
                            <li className="fk-breadcrumb__list">
                              <span className="pl-3 t-link fk-breadcrumb__link text-capitalize">
                                {_t(t("Finished Goods Adjustment Report"))}
                              </span>
                            </li>
                          </ul>
                          <div className="col-6 d-flex justify-content-end p-0">
                            <div className="d-inline mr-3 d-flex align-items-center">
                              <input
                                type="radio"
                                className="form-check-input pointer-cursor"
                                id="excel_report"
                                name="excel_report"
                                value="excel"
                                onChange={(e) => {
                                  handleOption(e);
                                }}
                                checked={option === "excel"}
                              />
                              <label
                                className="form-radio-label pointer-cursor ml-2 pt-1 text-primary"
                                htmlFor="excel_report"
                                style={{
                                  fontSize: "16px",
                                  borderRadius: "5px",
                                }}
                              >
                                <i
                                  className="fa fa-table"
                                  aria-hidden="true"
                                ></i>{" "}
                                {_t(t("Excel"))}
                              </label>
                            </div>

                            <div className="d-inline mr-2 d-flex align-items-center">
                              <input
                                type="radio"
                                className="form-check-input pointer-cursor"
                                id="print_report"
                                name="print_report"
                                value="print"
                                onChange={(e) => {
                                  handleOption(e);
                                }}
                                checked={option === "print"}
                              />
                              <label
                                className="form-radio-label pointer-cursor ml-2 pt-1 text-primary"
                                htmlFor="print_report"
                                style={{
                                  fontSize: "16px",
                                  borderRadius: "5px",
                                }}
                              >
                                <i
                                  className="fa fa-print"
                                  aria-hidden="true"
                                ></i>{" "}
                                {_t(t("Print"))}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-md-2 d-md-block">
                          <DatePicker
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control t-mb-15 mb-md-0"
                            placeholderText={_t(t("From date"))}
                            shouldCloseOnSelect={false}
                          />
                        </div>

                        <div className="col-md-2 d-md-block">
                          <DatePicker
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control t-mb-15 mb-md-0"
                            placeholderText={_t(t("To date"))}
                            shouldCloseOnSelect={false}
                          />
                        </div>

                        <div className="col-3">
                          <Select
                            options={branchForSearch && branchForSearch}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            value={branch}
                            isClearable
                            classNamePrefix="select"
                            className="table-text"
                            onChange={handleBranch}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select a branch")) + ".."}
                          />
                        </div>

                        <div className="col-3">
                          <Select
                            options={foodForPOS && foodForPOS}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            value={item}
                            isClearable
                            classNamePrefix="select"
                            className="table-text"
                            onChange={handleItem}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select item")) + ".."}
                          />
                        </div>

                        <div className="col-2 t-mb-15 mb-md-0 text-right">
                          <button
                            className="ml-1 btn btn-block btn-primary sm-text py-2 rounded"
                            onClick={(e) => getBranchWiseSelected()}
                          >
                            FG Adjustment Report
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
    </>
  );
};

export default FgAdjustmentReport;
